import { Config } from "../../Config";
import { ILaya } from "../../ILaya";
import { Loader } from "../net/Loader";
import { Browser } from "../utils/Browser";
const EXPIRE_TIME = 30000;
const CHECK_INTERVAL = 10000;
export class AudioDataCache {
    constructor() {
        this._size = 0;
        this._lastCheck = 0;
        this._items = {};
    }
    add(url, obj, size) {
        if (this._items[url])
            this._size -= this._items[url].size;
        let time = Browser.now();
        this._items[url] = { obj, size: size, time };
        this._size += size;
        if (this._size > Config.audioBufferCacheMaxSize && time - this._lastCheck > CHECK_INTERVAL) {
            this._lastCheck = time;
            for (let key in this._items) {
                let item2 = this._items[key];
                if (time - item2.time > EXPIRE_TIME) {
                    this._size -= item2.size;
                    delete this._items[key];
                    console.debug("AudioDataCache: remove " + key);
                }
            }
        }
    }
    get(url, callback, callbackThis) {
        let item = this._items[url];
        if (item != null) {
            item.time = Browser.now();
            callback.call(callbackThis, item.obj);
            return;
        }
        ILaya.loader.load(url, { type: Loader.SOUND, cache: false }).then(buffer => {
            if (buffer)
                this.add(url, buffer, buffer.__byteLength);
            callback.call(callbackThis, buffer);
        });
    }
}
